/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * CyrenCare API
 * CyrenCare NestJS REST API for healthcare survey platform
 * OpenAPI spec version: 2.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  FileControllerUploadFileBody,
  FileResponseDto,
  QuestionImageResponseDto,
  UploadFileResponseDto
} from '.././types'
import { customInstance } from '../../custom-instance';
import type { ErrorType } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Upload a file
 */
export const fileControllerUploadFile = (
    fileControllerUploadFileBody: FileControllerUploadFileBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      const formData = new FormData();
formData.append('file', fileControllerUploadFileBody.file)

      return customInstance<UploadFileResponseDto>(
      {url: `/files/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getFileControllerUploadFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileControllerUploadFile>>, TError,{data: FileControllerUploadFileBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof fileControllerUploadFile>>, TError,{data: FileControllerUploadFileBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileControllerUploadFile>>, {data: FileControllerUploadFileBody}> = (props) => {
          const {data} = props ?? {};

          return  fileControllerUploadFile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FileControllerUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof fileControllerUploadFile>>>
    export type FileControllerUploadFileMutationBody = FileControllerUploadFileBody
    export type FileControllerUploadFileMutationError = ErrorType<void>

    /**
 * @summary Upload a file
 */
export const useFileControllerUploadFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileControllerUploadFile>>, TError,{data: FileControllerUploadFileBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof fileControllerUploadFile>>,
        TError,
        {data: FileControllerUploadFileBody},
        TContext
      > => {

      const mutationOptions = getFileControllerUploadFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get file by ID
 */
export const fileControllerGetFile = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileResponseDto>(
      {url: `/files/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getFileControllerGetFileQueryKey = (id: number,) => {
    return [`/files/${id}`] as const;
    }

    
export const getFileControllerGetFileInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof fileControllerGetFile>>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFileControllerGetFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fileControllerGetFile>>> = ({ signal }) => fileControllerGetFile(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData> & { queryKey: QueryKey }
}

export type FileControllerGetFileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof fileControllerGetFile>>>
export type FileControllerGetFileInfiniteQueryError = ErrorType<void>

/**
 * @summary Get file by ID
 */
export const useFileControllerGetFileInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof fileControllerGetFile>>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFileControllerGetFileInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFileControllerGetFileQueryOptions = <TData = Awaited<ReturnType<typeof fileControllerGetFile>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFileControllerGetFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fileControllerGetFile>>> = ({ signal }) => fileControllerGetFile(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData> & { queryKey: QueryKey }
}

export type FileControllerGetFileQueryResult = NonNullable<Awaited<ReturnType<typeof fileControllerGetFile>>>
export type FileControllerGetFileQueryError = ErrorType<void>

/**
 * @summary Get file by ID
 */
export const useFileControllerGetFile = <TData = Awaited<ReturnType<typeof fileControllerGetFile>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFileControllerGetFileQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Link an image to a question
 */
export const fileControllerLinkImageToQuestion = (
    questionId: number,
    fileId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<QuestionImageResponseDto>(
      {url: `/files/questions/${questionId}/images/${fileId}`, method: 'POST'
    },
      options);
    }
  


export const getFileControllerLinkImageToQuestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileControllerLinkImageToQuestion>>, TError,{questionId: number;fileId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof fileControllerLinkImageToQuestion>>, TError,{questionId: number;fileId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileControllerLinkImageToQuestion>>, {questionId: number;fileId: number}> = (props) => {
          const {questionId,fileId} = props ?? {};

          return  fileControllerLinkImageToQuestion(questionId,fileId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FileControllerLinkImageToQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof fileControllerLinkImageToQuestion>>>
    
    export type FileControllerLinkImageToQuestionMutationError = ErrorType<unknown>

    /**
 * @summary Link an image to a question
 */
export const useFileControllerLinkImageToQuestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileControllerLinkImageToQuestion>>, TError,{questionId: number;fileId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof fileControllerLinkImageToQuestion>>,
        TError,
        {questionId: number;fileId: number},
        TContext
      > => {

      const mutationOptions = getFileControllerLinkImageToQuestionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Remove all images from a question
 */
export const fileControllerUnlinkImageFromQuestion = (
    questionId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/files/questions/${questionId}/images`, method: 'DELETE'
    },
      options);
    }
  


export const getFileControllerUnlinkImageFromQuestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileControllerUnlinkImageFromQuestion>>, TError,{questionId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof fileControllerUnlinkImageFromQuestion>>, TError,{questionId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileControllerUnlinkImageFromQuestion>>, {questionId: number}> = (props) => {
          const {questionId} = props ?? {};

          return  fileControllerUnlinkImageFromQuestion(questionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FileControllerUnlinkImageFromQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof fileControllerUnlinkImageFromQuestion>>>
    
    export type FileControllerUnlinkImageFromQuestionMutationError = ErrorType<unknown>

    /**
 * @summary Remove all images from a question
 */
export const useFileControllerUnlinkImageFromQuestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileControllerUnlinkImageFromQuestion>>, TError,{questionId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof fileControllerUnlinkImageFromQuestion>>,
        TError,
        {questionId: number},
        TContext
      > => {

      const mutationOptions = getFileControllerUnlinkImageFromQuestionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get images linked to a question
 */
export const fileControllerGetQuestionImages = (
    questionId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuestionImageResponseDto>(
      {url: `/files/questions/${questionId}/images`, method: 'GET', signal
    },
      options);
    }
  

export const getFileControllerGetQuestionImagesQueryKey = (questionId: number,) => {
    return [`/files/questions/${questionId}/images`] as const;
    }

    
export const getFileControllerGetQuestionImagesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>>, TError = ErrorType<unknown>>(questionId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFileControllerGetQuestionImagesQueryKey(questionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>> = ({ signal }) => fileControllerGetQuestionImages(questionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>, TError, TData> & { queryKey: QueryKey }
}

export type FileControllerGetQuestionImagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>>
export type FileControllerGetQuestionImagesInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get images linked to a question
 */
export const useFileControllerGetQuestionImagesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>>, TError = ErrorType<unknown>>(
 questionId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFileControllerGetQuestionImagesInfiniteQueryOptions(questionId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFileControllerGetQuestionImagesQueryOptions = <TData = Awaited<ReturnType<typeof fileControllerGetQuestionImages>>, TError = ErrorType<unknown>>(questionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFileControllerGetQuestionImagesQueryKey(questionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>> = ({ signal }) => fileControllerGetQuestionImages(questionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>, TError, TData> & { queryKey: QueryKey }
}

export type FileControllerGetQuestionImagesQueryResult = NonNullable<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>>
export type FileControllerGetQuestionImagesQueryError = ErrorType<unknown>

/**
 * @summary Get images linked to a question
 */
export const useFileControllerGetQuestionImages = <TData = Awaited<ReturnType<typeof fileControllerGetQuestionImages>>, TError = ErrorType<unknown>>(
 questionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetQuestionImages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFileControllerGetQuestionImagesQueryOptions(questionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



